import React from 'react'
import { Div } from 'konsys-ui'
import {
  ActionSelector, HeaderLabel, CellText, TruckBrandFilter, SenderLocationFilter, ReceiverLocationFilter,
} from '../../../components/recommend-fuel-components'


const getColumns = (onEditClick, onDeleteClick) => [{
    Header: <HeaderLabel>ยี่ห้อรถ</HeaderLabel>,
    accessor: 'truckBrand.name',
    sortable: false,
    filterable: true,
    Cell: props => <CellText style={{ fontWeight: 600 }}>{props.value}</CellText>,
    Filter: ({ onChange, filter }) => <TruckBrandFilter onChange={onChange} value={filter ? filter.value : undefined} />,
    width: 200,
  }, {
    Header: <HeaderLabel>ต้นทาง</HeaderLabel>,
    accessor: 'senderLocation.name',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange, filter }) => <SenderLocationFilter onChange={onChange} value={filter ? filter.value : undefined} />,
    width: 250,
  }, {
    Header: <HeaderLabel>ปลายทาง</HeaderLabel>,
    accessor: 'receiverLocation.name',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange, filter }) => <ReceiverLocationFilter onChange={onChange} value={filter ? filter.value : undefined} />,
    width: 300,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          น้ำมันที่แนะนำ
        </HeaderLabel>
      </Div>
    ),
    accessor: 'amount',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value ? `${props.value} ลิตร` : '-'}</CellText>,
    width: 150,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} onEditClick={onEditClick} onDeleteClick={onDeleteClick} />,
    width: 150,
  }]

export default {
  getColumns,
}
